import { rpcCall } from '@scayle/storefront-nuxt'

const SYNC_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes

const SYNC_STORAGE_KEY = 'customer_sync_timestamp'

export const useCustomerSync = () => {
  const nuxtApp = useNuxtApp()
  const { user } = useAgsUser()
  const currentShop = useCurrentShop()

  const getSyncTimestamp = (): number | null => {
    if (import.meta.server || typeof localStorage === 'undefined') {
      return null
    }

    try {
      const stored = localStorage.getItem(SYNC_STORAGE_KEY)
      return stored ? parseInt(stored, 10) : null
    } catch {
      return null
    }
  }

  const updateSyncTimestamp = () => {
    if (import.meta.server || typeof localStorage === 'undefined') {
      return
    }

    try {
      localStorage.setItem(SYNC_STORAGE_KEY, String(Date.now()))
    } catch (e) {
      console.error('Failed to update sync timestamp', { e })
    }
  }

  const isSyncAllowed = (): boolean => {
    const lastSync = getSyncTimestamp()

    if (!lastSync) {
      return true
    }

    const timeSinceLastSync = Date.now() - lastSync
    return timeSinceLastSync >= SYNC_INTERVAL_MS
  }

  const tryTriggerSync = async () => {
    if (!user.value?.id || !currentShop.value) {
      return { success: false, reason: 'missing_data' }
    }

    if (!isSyncAllowed()) {
      return { success: false, reason: 'rate_limited' }
    }

    try {
      const syncCall = rpcCall(nuxtApp, 'syncCustomerData', currentShop.value)

      const result = await syncCall({})

      if (result.success) {
        updateSyncTimestamp()
      }

      return result
    } catch (e) {
      return { success: false, reason: 'api_error', e }
    }
  }


  return {
    tryTriggerSync,
    SYNC_INTERVAL_MS,
  }
}
